import { StorefrontPackageView } from '@zola/svc-marketplace-ts-types';

import _sortBy from 'lodash/sortBy';

const sortPackages = (packages: StorefrontPackageView[]) => {
  return _sortBy(packages, ['displayOrder']);
};

export { sortPackages };
